/**
 * Type output options
 */
export var TypeOutput = /*#__PURE__*/function (TypeOutput) {
  TypeOutput[TypeOutput["Number"] = 0] = "Number";
  TypeOutput[TypeOutput["BigInt"] = 1] = "BigInt";
  TypeOutput[TypeOutput["Uint8Array"] = 2] = "Uint8Array";
  TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
  return TypeOutput;
}(TypeOutput || {});

